export * from './configurationController.service';
import { ConfigurationControllerService } from './configurationController.service';
export * from './userController.service';
import { UserControllerService } from './userController.service';
export const APIS = [ConfigurationControllerService, UserControllerService];
